import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/authContext";
import Text from "./text";
import Images from "./images";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, logout, user } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isWebOptionsDropdownOpen, setIsWebOptionsDropdownOpen] =
    useState(false);
  const [isApEapcetDropdownOpen, setIsApEapcetDropdownOpen] = useState(false);
  const [isAuthDropdownOpen, setIsAuthDropdownOpen] = useState(false);
  const [isMobileWebOptionsOpen, setIsMobileWebOptionsOpen] = useState(false);
  const [isMobileCollegeDirOpen, setIsMobileCollegeDirOpen] = useState(false);

  const webOptionsDropdownRef = useRef();
  const apEapcetDropdownRef = useRef();
  const authDropdownRef = useRef();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleLogout = async () => {
    await logout();
    navigate("/");
    setIsMenuOpen(false); // Close mobile menu on logout
    closeAllDropdowns();
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        webOptionsDropdownRef.current &&
        !webOptionsDropdownRef.current.contains(event.target)
      ) {
        setIsWebOptionsDropdownOpen(false);
      }
      if (
        apEapcetDropdownRef.current &&
        !apEapcetDropdownRef.current.contains(event.target)
      ) {
        setIsApEapcetDropdownOpen(false);
      }
      if (
        authDropdownRef.current &&
        !authDropdownRef.current.contains(event.target)
      ) {
        setIsAuthDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const closeAllDropdowns = () => {
    setIsWebOptionsDropdownOpen(false);
    setIsApEapcetDropdownOpen(false);
    setIsAuthDropdownOpen(false);
  };

  const closeMobileMenu = () => {
    setIsMenuOpen(false);
    setIsMobileWebOptionsOpen(false); // Also close mobile accordion
    setIsMobileCollegeDirOpen(false);
  };

  return (
    <nav className="bg-gradient-to-r from-blue-600 to-blue-800 shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link
            to="/"
            className="text-white text-xl md:text-2xl font-bold flex items-center transition-transform hover:scale-105"
            onClick={() => {
              closeMobileMenu();
              closeAllDropdowns();
            }}
          >
            <img
              src={Images.Logo}
              alt="CollegeRank Logo"
              className="h-10 w-10 rounded-full bg-white p-1 shadow mr-2 object-cover"
              style={{ border: "2px solid #FFA500" }} // Optional: orange border for accent
            />
            <span>{Text.navTitle}</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4 nav">
            {/* Home link */}
            <Link
              to="/"
              className={`text-white hover:text-blue-200 px-3 py-2 rounded-md text-sm font-medium transition-colors relative
                ${
                  isActive("/")
                    ? "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-white"
                    : ""
                }`}
              onClick={closeAllDropdowns}
            >
              Home
            </Link>

            {/* Create List Button */}
            <Link
              to="/filter"
              className={`text-white hover:text-blue-200 px-3 py-2 rounded-md text-sm font-medium transition-colors relative
                ${
                  isActive("/filter")
                    ? "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-white"
                    : ""
                }`}
              onClick={closeAllDropdowns}
            >
              Create List
            </Link>

            {/* Web Options Dropdown */}
            <div className="relative" ref={webOptionsDropdownRef}>
              <button
                onClick={() => {
                  setIsWebOptionsDropdownOpen((v) => !v);
                  setIsApEapcetDropdownOpen(false);
                  setIsAuthDropdownOpen(false);
                }}
                className={`text-white hover:text-blue-200 px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center group relative
                  ${
                    isActive("/create-ap-2025-engg-list") ||
                    isActive("/create-ap-2025-phar-list")
                      ? "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-white"
                      : ""
                  }`}
                type="button"
              >
                Web Options
                <svg
                  className={`h-4 w-4 ml-2 transition-transform ${
                    isWebOptionsDropdownOpen ? "rotate-180" : ""
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {isWebOptionsDropdownOpen && (
                <div className="absolute mt-2 w-56 bg-white rounded-md shadow-lg z-20 right-0">
                  <Link
                    to="/create-ap-2025-engg-list"
                    className={`block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 ${
                      isActive("/create-ap-2025-engg-list")
                        ? "bg-blue-100 font-semibold text-blue-700"
                        : ""
                    }`}
                    onClick={() => setIsWebOptionsDropdownOpen(false)}
                  >
                    AP 2025 Engineering
                  </Link>
                  <Link
                    to="/create-ap-2025-phar-list"
                    className={`block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 ${
                      isActive("/create-ap-2025-phar-list")
                        ? "bg-blue-100 font-semibold text-blue-700"
                        : ""
                    }`}
                    onClick={() => setIsWebOptionsDropdownOpen(false)}
                  >
                    AP 2025 Pharmacy
                  </Link>
                </div>
              )}
            </div>

            {/* AP EAPCET 2024 Dropdown */}
            <div className="relative" ref={apEapcetDropdownRef}>
              <button
                onClick={() => {
                  setIsApEapcetDropdownOpen((v) => !v);
                  setIsWebOptionsDropdownOpen(false);
                  setIsAuthDropdownOpen(false);
                }}
                className={`text-white hover:text-blue-200 px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center group relative
                  ${
                    isActive("/ap-2024-colleges") ||
                    isActive("/ap-2024-branches") ||
                    isActive("/new-branches-2024") ||
                    isActive("/ap-2025-engg-colleges") ||
                    isActive("/ap-2025-pharmacy-colleges")
                      ? "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-white"
                      : ""
                  }`}
                type="button"
              >
                College Directories
                <svg
                  className={`h-4 w-4 ml-2 transition-transform ${
                    isApEapcetDropdownOpen ? "rotate-180" : ""
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {isApEapcetDropdownOpen && (
                <div className="absolute mt-2 w-56 bg-white rounded-md shadow-lg z-20 right-0">
                  <Link
                    to="/ap-2024-colleges"
                    className={`block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 ${
                      isActive("/ap-2024-colleges")
                        ? "bg-blue-100 font-semibold text-blue-700"
                        : ""
                    }`}
                    onClick={() => setIsApEapcetDropdownOpen(false)}
                  >
                    AP 2024 Colleges
                  </Link>
                  <Link
                    to="/ap-2024-branches"
                    className={`block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 ${
                      isActive("/ap-2024-branches")
                        ? "bg-blue-100 font-semibold text-blue-700"
                        : ""
                    }`}
                    onClick={() => setIsApEapcetDropdownOpen(false)}
                  >
                    AP 2024 Branches
                  </Link>
                  <Link
                    to="/ap-2025-engg-colleges"
                    className={`block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 ${
                      isActive("/ap-2025-engg-colleges")
                        ? "bg-blue-100 font-semibold text-blue-700"
                        : ""
                    }`}
                    onClick={() => setIsApEapcetDropdownOpen(false)}
                  >
                    AP 2025 Engg Colleges
                  </Link>
                  <Link
                    to="/ap-2025-pharmacy-colleges"
                    className={`block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 ${
                      isActive("/ap-2025-pharmacy-colleges")
                        ? "bg-blue-100 font-semibold text-blue-700"
                        : ""
                    }`}
                    onClick={() => setIsApEapcetDropdownOpen(false)}
                  >
                    AP 2025 Pharmacy Colleges
                  </Link>
                  {/* <Link
                    to="/new-branches-2024"
                    className={`block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 ${
                      isActive("/new-branches-2024") ? "bg-blue-100 font-semibold text-blue-700" : ""
                    }`}
                    onClick={() => setIsApEapcetDropdownOpen(false)}
                  >
                    AP New Branches
                  </Link> */}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`text-white hover:text-blue-200 px-3 py-2 rounded-md text-sm font-medium transition-colors relative
                ${
                  isActive("/about")
                    ? "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-white"
                    : ""
                }`}
              onClick={closeAllDropdowns}
            >
              About
            </Link>

            {isAuthenticated ? (
              <>
                <Link
                  to="/profile"
                  className={`text-white hover:text-blue-200 px-3 py-2 rounded-md text-sm font-medium transition-colors relative flex items-center
                    ${
                      isActive("/profile")
                        ? "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-white"
                        : ""
                    }`}
                  onClick={closeAllDropdowns}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    {" "}
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />{" "}
                  </svg>
                  {user?.name ? `${user.name}` : "Profile"}
                </Link>
              </>
            ) : (
              // Login/Signup Dropdown for Desktop
              <div className="relative" ref={authDropdownRef}>
                <button
                  onClick={() => {
                    setIsAuthDropdownOpen((v) => !v);
                    setIsWebOptionsDropdownOpen(false);
                    setIsApEapcetDropdownOpen(false);
                  }}
                  className={`text-white hover:text-blue-200 px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center group relative
                  ${
                    isActive("/login") || isActive("/signup")
                      ? "after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-white"
                      : ""
                  }`}
                  type="button"
                >
                  Account
                  <svg
                    className={`h-4 w-4 ml-2 transition-transform ${
                      isAuthDropdownOpen ? "rotate-180" : ""
                    }`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>
                {isAuthDropdownOpen && (
                  <div className="absolute mt-2 w-48 bg-white rounded-md shadow-lg z-20 right-0">
                    <Link
                      to="/login"
                      className={`block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 ${
                        isActive("/login")
                          ? "bg-blue-100 font-semibold text-blue-700"
                          : ""
                      }`}
                      onClick={() => setIsAuthDropdownOpen(false)}
                    >
                      Login
                    </Link>
                    <Link
                      to="/signup"
                      className={`block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 ${
                        isActive("/signup")
                          ? "bg-blue-100 font-semibold text-blue-700"
                          : ""
                      }`}
                      onClick={() => setIsAuthDropdownOpen(false)}
                    >
                      Sign Up
                    </Link>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={toggleMenu}
              className="text-white hover:text-blue-200 focus:outline-none focus:text-blue-200"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-2 px-2 space-y-1 sm:px-3 bg-blue-700 rounded-md mt-1 mb-2">
            {/* Home link for mobile */}
            <Link
              to="/"
              onClick={closeMobileMenu}
              className={`text-white hover:bg-blue-600 px-3 py-3 rounded-md textBase font-medium flex items-center 
                ${isActive("/") ? "bg-blue-600 border-l-4 border-white" : ""}`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {" "}
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />{" "}
              </svg>
              Home
            </Link>

            {/* Create List for mobile */}
            <Link
              to="/filter"
              onClick={closeMobileMenu}
              className={`text-white hover:bg-blue-600 px-3 py-3 rounded-md text-base font-medium flex items-center
                ${
                  isActive("/filter")
                    ? "bg-blue-600 border-l-4 border-white"
                    : ""
                }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {" "}
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                />{" "}
              </svg>
              Create List
            </Link>

            {/* Web Options for mobile (Accordion) */}
            <div>
              <button
                onClick={() => setIsMobileWebOptionsOpen((prev) => !prev)}
                className={`w-full text-left text-white hover:bg-blue-600 px-3 py-3 rounded-md text-base font-medium flex items-center justify-between
                  ${
                    isActive("/create-ap-2025-engg-list") ||
                    isActive("/create-ap-2025-phar-list")
                      ? "bg-blue-600 border-l-4 border-white"
                      : ""
                  }`}
              >
                <span className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  Web Options
                </span>
                <svg
                  className={`h-5 w-5 transition-transform ${
                    isMobileWebOptionsOpen ? "rotate-180" : ""
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {isMobileWebOptionsOpen && (
                <div className="pl-8 pr-2 py-1 space-y-1">
                  <Link
                    to="/create-ap-2025-engg-list"
                    onClick={closeMobileMenu}
                    className={`block text-white hover:bg-blue-600 px-3 py-2 rounded-md text-sm font-medium ${
                      isActive("/create-ap-2025-engg-list") ? "bg-blue-500" : ""
                    }`}
                  >
                    AP 2025 Engineering
                  </Link>
                  <Link
                    to="/create-ap-2025-phar-list"
                    onClick={closeMobileMenu}
                    className={`block text-white hover:bg-blue-600 px-3 py-2 rounded-md text-sm font-medium ${
                      isActive("/create-ap-2025-phar-list") ? "bg-blue-500" : ""
                    }`}
                  >
                    AP 2025 Pharmacy
                  </Link>
                </div>
              )}
            </div>

            {/* College Directories for mobile (Accordion) */}
            <div>
              <button
                onClick={() => setIsMobileCollegeDirOpen((prev) => !prev)}
                className={`w-full text-left text-white hover:bg-blue-600 px-3 py-3 rounded-md textBase font-medium flex items-center justify-between
                  ${
                    isActive("/ap-2024-colleges") ||
                    isActive("/ap-2024-branches") ||
                    isActive("/ap-2025-engg-colleges") ||
                    isActive("/ap-2025-pharmacy-colleges")
                      ? "bg-blue-600 border-l-4 border-white"
                      : ""
                  }`}
              >
                <span className="flex items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    />
                  </svg>
                  College Directories
                </span>
                <svg
                  className={`h-5 w-5 transition-transform ${
                    isMobileCollegeDirOpen ? "rotate-180" : ""
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {isMobileCollegeDirOpen && (
                <div className="pl-8 pr-2 py-1 space-y-1">
                  <Link
                    to="/ap-2024-colleges"
                    onClick={closeMobileMenu}
                    className={`block text-white hover:bg-blue-600 px-3 py-2 rounded-md text-sm font-medium ${
                      isActive("/ap-2024-colleges") ? "bg-blue-500" : ""
                    }`}
                  >
                    AP 2024 Colleges
                  </Link>
                  <Link
                    to="/ap-2024-branches"
                    onClick={closeMobileMenu}
                    className={`block text-white hover:bg-blue-600 px-3 py-2 rounded-md text-sm font-medium ${
                      isActive("/ap-2024-branches") ? "bg-blue-500" : ""
                    }`}
                  >
                    AP 2024 Branches
                  </Link>
                  <Link
                    to="/ap-2025-engg-colleges"
                    onClick={closeMobileMenu}
                    className={`block text-white hover:bg-blue-600 px-3 py-2 rounded-md text-sm font-medium ${
                      isActive("/ap-2025-engg-colleges") ? "bg-blue-500" : ""
                    }`}
                  >
                    AP 2025 Engg Colleges
                  </Link>
                  <Link
                    to="/ap-2025-pharmacy-colleges"
                    onClick={closeMobileMenu}
                    className={`block text-white hover:bg-blue-600 px-3 py-2 rounded-md text-sm font-medium ${
                      isActive("/ap-2025-pharmacy-colleges")
                        ? "bg-blue-500"
                        : ""
                    }`}
                  >
                    AP 2025 Pharmacy Colleges
                  </Link>
                  {/* <Link
                    to="/new-branches-2024"
                    className={`block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 ${
                      isActive("/new-branches-2024") ? "bg-blue-100 font-semibold text-blue-700" : ""
                    }`}
                    onClick={() => setIsApEapcetDropdownOpen(false)}
                  >
                    AP New Branches
                  </Link> */}
                </div>
              )}
            </div>

            {/* AP Colleges 2024 for mobile */}
            {/* <Link
              to="/ap-2024-colleges"
              onClick={closeMobileMenu}
              className={`text-white hover:bg-blue-600 px-3 py-3 rounded-md textBase font-medium flex items-center 
                ${isActive("/ap-2024-colleges") ? "bg-blue-600 border-l-4 border-white" : ""}`}
            >
               <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              AP Colleges
            </Link> */}

            {/* AP Branches 2024 for mobile */}
            {/* <Link
              to="/ap-2024-branches"
              onClick={closeMobileMenu}
              className={`text-white hover:bg-blue-600 px-3 py-3 rounded-md textBase font-medium flex items-center 
                ${isActive("/ap-2024-branches") ? "bg-blue-600 border-l-4 border-white" : ""}`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
              </svg>
              AP Branches
            </Link> */}

            {/* New Branches 2024 for mobile */}
            {/* <Link
              to="/new-branches-2024"
              onClick={closeMobileMenu}
              className={`text-white hover:bg-blue-600 px-3 py-3 rounded-md textBase font-medium flex items-center 
                ${isActive("/new-branches-2024") ? "bg-blue-600 border-l-4 border-white" : ""}`}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
              </svg>
              New Branches
            </Link> */}

            <Link
              to="/about"
              onClick={closeMobileMenu}
              className={`text-white hover:bg-blue-600 px-3 py-3 rounded-md textBase font-medium flex items-center
                ${
                  isActive("/about")
                    ? "bg-blue-600 border-l-4 border-white"
                    : ""
                }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {" "}
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />{" "}
              </svg>
              About
            </Link>

            {isAuthenticated ? (
              <>
                <Link
                  to="/profile"
                  onClick={closeMobileMenu}
                  className={`text-white hover:bg-blue-600 px-3 py-3 rounded-md textBase font-medium flex items-center
                    ${
                      isActive("/profile")
                        ? "bg-blue-600 border-l-4 border-white"
                        : ""
                    }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    {" "}
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />{" "}
                  </svg>
                  {user?.name ? `${user.name}` : "Profile"}
                </Link>
                <button
                  onClick={handleLogout}
                  className="w-full text-left text-white hover:bg-blue-600 px-3 py-3 rounded-md textBase font-medium flex items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    {" "}
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    />{" "}
                  </svg>
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  onClick={closeMobileMenu}
                  className={`text-white hover:bg-blue-600 px-3 py-3 rounded-md textBase font-medium flex items-center
                    ${
                      isActive("/login")
                        ? "bg-blue-600 border-l-4 border-white"
                        : ""
                    }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    {" "}
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                    />{" "}
                  </svg>
                  Login
                </Link>
                <Link
                  to="/signup"
                  onClick={closeMobileMenu}
                  className={`text-white hover:bg-blue-600 px-3 py-3 rounded-md textBase font-medium flex items-center
                    ${
                      isActive("/signup")
                        ? "bg-blue-600 border-l-4 border-white"
                        : ""
                    }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-2"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    {" "}
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                    />{" "}
                  </svg>
                  Sign Up
                </Link>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
